import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    title: '',
    description: '',
    site: '',
    twitterAccount: '',
    twitterCard: 'summary',
    image: '',
    imageWidth: '',
    imageHeight: '',
    imageType: '',
    logo: '',
    kind: '',
    url: ''
  },
  getters: {
    all (state: any) {
      return {
        title: state.title,
        description: state.description,
        card: state.card,
        image: state.image,
        imageWidth: state.imageWidth,
        imageHeight: state.imageHeight,
        twitterAccount: state.twitterAccount,
        twitterCard: state.twitterCard,
        imageType: state.imageType,
        logo: state.logo,
        kind: state.kind,
        url: state.url
      }
    }
  },
  actions: {
    update (context: any, payload: string) {
      context.commit('update', payload)
    }
  },
  mutations: {
    update (state: any, payload: any) {
      let keyList = Object.keys(payload)
      keyList.forEach((item) => {
        Vue.set(state, item, payload[item])
      })
    }
  }
}
